import Logger from './logger';

export default class Upsell {
  productMap = [
    {
      handle: 'muse-s-gen-2-subscription',
      upsells: [
        {
          title: 'Muse S Case (Bundled)',
          image: 'https://cdn.shopify.com/s/files/1/0348/7053/files/MuseSCase_2_6c0d98c2-e1be-4875-a46a-27dff6bf5166.png?v=1684517206',
          us: {
            id: 32189940432999,
            price: '$29.99',
            comparePrice: '$39.99'
          },
          ca: {
            id: 32239675080790,
            price: '$29.99',
            comparePrice: '$39.99'
          },
          eu: {
            id: 32656754311256,
            price: '€26.99',
            comparePrice: '€36.99'
          },
          intl: {
            id: 31670323183677,
            price: '$29.99',
            comparePrice: '$39.99'
          }
        },
        {
          title: 'Muse S (Gen 2) Additional Fabric Band (Bundled)',
          image: 'https://cdn.shopify.com/s/files/1/0348/7053/files/Band_9d8d71df-77b2-46a5-90b2-565ec4c64b46.png?v=1684517179',
          us: {
            id: 39496456929383,
            price: '$44.99',
            comparePrice: '$79.99'
          },
          ca: {
            id: 39564182585430,
            price: '$59.99',
            comparePrice: '$99.99'
          },
          eu: {
            id: 39661519863896,
            price: '€41.99',
            comparePrice: '€69.99'
          },
          intl: {
            id: 39419457962045,
            price: '$47.99',
            comparePrice: '$79.99'
          }
        }
      ]
    },
    {
      handle: 'muse-s-gen-2',
      upsells: [
        {
          title: 'Muse S Case (Bundled)',
          image: 'https://cdn.shopify.com/s/files/1/0348/7053/files/MuseSCase_2_6c0d98c2-e1be-4875-a46a-27dff6bf5166.png?v=1684517206',
          us: {
            id: 32189940432999,
            price: '$29.99',
            comparePrice: '$39.99'
          },
          ca: {
            id: 32239675080790,
            price: '$29.99',
            comparePrice: '$39.99'
          },
          eu: {
            id: 32656754311256,
            price: '€26.99',
            comparePrice: '€36.99'
          },
          intl: {
            id: 31670323183677,
            price: '$29.99',
            comparePrice: '$39.99'
          }
        },
        {
          title: 'Muse S (Gen 2) Additional Fabric Band (Bundled)',
          image: 'https://cdn.shopify.com/s/files/1/0348/7053/files/Band_9d8d71df-77b2-46a5-90b2-565ec4c64b46.png?v=1684517179',
          us: {
            id: 39496456929383,
            price: '$44.99',
            comparePrice: '$79.99'
          },
          ca: {
            id: 39564182585430,
            price: '$59.99',
            comparePrice: '$99.99'
          },
          eu: {
            id: 39661519863896,
            price: '€41.99',
            comparePrice: '€69.99'
          },
          intl: {
            id: 39419457962045,
            price: '$47.99',
            comparePrice: '$79.99'
          }
        },
        {
          title: 'Annual Premium Subscription (Bundled)',
          image: 'https://cdn.shopify.com/s/files/1/0348/7053/products/Shopify.png?v=1678287289',
          us: {
            id: 20913367875687,
            price: '$49.99',
            comparePrice: '$94.99'
          },
          ca: {
            id: 28312710840406,
            price: '$68.99',
            comparePrice: '$124.99'
          },
          eu: {
            id: 29651897385048,
            price: '€39.99',
            comparePrice: '£78.99'
          },
          intl: {
            id: 28582379388989,
            price: '$49.99',
            comparePrice: '$94.99'
          }
        },
      ]
    },
    {
      handle: 'muse-2',
      upsells: [
        {
          title: 'Muse 2 Hard Carrying Case (Bundled)',
          image: 'https://cdn.shopify.com/s/files/1/0348/7053/files/Muse2Case.png?v=1684517151',
          us: {
            id: 12890248380519,
            price: '$29.99',
            comparePrice: '$39.99'
          },
          ca: {
            id: 12791986028630,
            price: '$29.99',
            comparePrice: '$39.99'
          },
          eu: {
            id: 20623451062360,
            price: '€26.99',
            comparePrice: '€36.99'
          },
          intl: {
            id: 28564131053629,
            price: '$29.99',
            comparePrice: '$39.99'
          }
        },
        {
          title: 'Annual Premium Subscription (Bundled)',
          image: 'https://cdn.shopify.com/s/files/1/0348/7053/products/Shopify.png?v=1678287289',
          us: {
            id: 20913367875687,
            price: '$49.99',
            comparePrice: '$94.99'
          },
          ca: {
            id: 28312710840406,
            price: '$68.99',
            comparePrice: '$124.99'
          },
          eu: {
            id: 29651897385048,
            price: '€39.99',
            comparePrice: '£78.99'
          },
          intl: {
            id: 28582379388989,
            price: '$49.99',
            comparePrice: '$94.99'
          }
        },
      ]
    },
    {
      handle: 'muse-2-premium-subscription-bundle',
      upsells: [
        {
          title: 'Muse 2 Hard Carrying Case (Bundled)',
          image: 'https://cdn.shopify.com/s/files/1/0348/7053/files/Muse2Case.png?v=1684517151',
          us: {
            id: 12890248380519,
            price: '$29.99',
            comparePrice: '$39.99'
          },
          ca: {
            id: 12791986028630,
            price: '$29.99',
            comparePrice: '$39.99'
          },
          eu: {
            id: 20623451062360,
            price: '€26.99',
            comparePrice: '€36.99'
          },
          intl: {
            id: 28564131053629,
            price: '$29.99',
            comparePrice: '$39.99'
          }
        }
      ]
    },
  ];

  constructor() {
    Logger.info(`Upsell > constructor`);
  }

  /**
   * Returns an array of upsell products based on product handle
   * @param {string} handle - handle of product found in cart JSON
   * @param {string} storeID - id or subdomain of store being shopped
   * @returns {Array<{title: string, id: number, price: string, image: string}>}
   */
  getProducts(handle, storeID) {
    Logger.info(`Upsell > getProducts(${handle}, ${storeID})`);
    const arr = [];
    const product = this.productMap.find(obj => obj.handle === handle);
    if (product) {
      product.upsells.forEach(obj => {
        const data = {
          title: obj.title, 
          id: obj[storeID].id, 
          price: obj[storeID].price || 'Add to cart to see price',
          comparePrice: obj[storeID].comparePrice,
          image: obj.image
        };
        arr.push(data);
      });
    }
    return arr;
  }
  
  /**
   * build/rebuild view of upsell products.
   * @param {Array<{title: string, id: number, price: string, comparePrice?: string, image: string}>} products - array of upsell products to display
   * @param {HTMLElement} parentElement - element to add upsell products to
   */
  updateView(products, parentElement) {
    Logger.info(`Upsell > updateView: products`, products);
    // remove children
    if (parentElement.childNodes.length) {
      while (parentElement.firstChild) {
        parentElement.removeChild(parentElement.firstChild);
      }
    }
    // add upsell line items
    products.forEach(item => {
      const itemDiv = document.createElement('div');
      itemDiv.className = 'sidecart__item';
      itemDiv.dataset.lineItemId = item.id;
      //
      const imageDiv = document.createElement('div');
      imageDiv.className = 'sidecart__item__image';
      if (item.image) imageDiv.style.backgroundImage = `url(${item.image}&width=130)`;
      itemDiv.appendChild(imageDiv);
      //
      const infoDiv = document.createElement('div');
      infoDiv.className = 'sidecart__item__info';
      //
      const title = document.createElement('p');
      title.className = 'sidecart__item__info__title';
      title.textContent = item.title;
      infoDiv.appendChild(title);
      itemDiv.appendChild(infoDiv);
      //
      const totalDiv = document.createElement('div');
      totalDiv.className = 'sidecart__item__total';
      //
      const priceEl = document.createElement('p');
      priceEl.className = 'sidecart__item__total__price';
      if (item.comparePrice) {
        const compareSpan = document.createElement('span');
        compareSpan.textContent = item.comparePrice;
        compareSpan.className = 'compare-price';
        priceEl.appendChild(compareSpan);
      }
      const priceSpan = document.createElement('span');
      priceSpan.textContent = item.price;
      priceEl.appendChild(priceSpan);
      totalDiv.appendChild(priceEl);
      //
      const addToCartBtn = document.createElement('button');
      addToCartBtn.textContent = 'add to cart';
      addToCartBtn.className = 'theme-button theme-button--primary theme-button--small';
      addToCartBtn.type = 'button';
      addToCartBtn.dataset.border = true;
      addToCartBtn.dataset.addToCart = true;
      addToCartBtn.dataset.product_id = item.id;
      totalDiv.appendChild(addToCartBtn);
      itemDiv.appendChild(totalDiv);
      parentElement.appendChild(itemDiv);
    });
  }
}
